export default __webpack_public_path__ + "8196f1fee53c35b6e8d5d5aef8c7460c7a77f2217d55fd15bc8ed2ecc57fd30c.png";